import axios from 'axios';
import store from '../store';
import queryString from 'query-string';
import {API_GET_CONTACT_GROUPS_URL, API_ROOT, translate} from '../app/utils';
import {webfulTrack} from '../app/utils/webful';
import {
	flash,
	ownershipChangeTarget,
	resetCollaborators,
	selectedCollaborator,
	sharedWithMeDisplayMode,
	updateCollaborators,
	enteredCollaboratorSearchValue,
	checkUpdates,
	getSharingDetailsPopup,
	share, resetAutoComplete, resetAddedCollaborators,
} from './sharingDetailsActions';
import {resetDomainGroup} from './domainGroupActions';
import {
	confirmContactResearch,
	contactDetailsEditMode,
	contactsAdvancedSearchRequest,
	contactSearchResultPageNumber,
	contactsLetter,
	contactsPageNumber,
	enteredContactSearchValue,
	enteredModalContactSearchValue,
	extendAddContactBtn,
	findContacts,
	isContactsAdvancedSearchDropDown as setIsContactsAdvancedSearchDropDown,
	isContactsSearchAdvancedMode,
	loadNextContacts,
	putLabelToAdd,
	resetContactSearchResult,
	resetModalContactSearchResult,
	selectContactToAdd,
	selectedContacts,
	selectLabelToAdd
} from './contactActions';
import {gmailAddOnMsgBar} from './msgBarActions';
import {tutorialPopup} from './popupActions';
import {waitingDirectoryGroupsLevel} from './directoryGroupActions';

export function refreshLabels() {
	return function (dispatch) {

		/*
		* Refresh status & labels rendering
		*/

		if (store.getState().contactsGroupItemReducer.getFilteredStatus !== null) {
			if (store.getState().contactsGroupItemReducer.getEnteredSearchValue !== '') {
				dispatch(labelsPageNumber(1));
				dispatch(findLabelsByType(store.getState().contactsGroupItemReducer.getFilteredStatus));
			} else {
				dispatch(labelsPageNumber(1));
				dispatch(findLabelsByType(store.getState().contactsGroupItemReducer.getFilteredStatus, store.getState().contactsGroupItemReducer.labelsPageSize));
			}
		} else {
			if (store.getState().contactsGroupItemReducer.getEnteredSearchValue !== '') {
				dispatch(labelsPageNumber(1));
				dispatch(findLabels(false, true));
			} else {
				dispatch(labelsPageNumber(1));

				dispatch(findLabels(store.getState().contactsGroupItemReducer.labelsPageSize, true));
			}
		}
	}
}

export function postCreateLabel(name, createdFromContactsSharing, ownProps) {
	let queryParameter = queryString.parse(window.location.search);

	return function (dispatch) {
		axios.post(API_ROOT + '/api/v11/label?label_name=' + encodeURIComponent(name), '', {withCredentials: true}).then(response => {

			//let queryParameter = queryString.parse(window.location.search);
			/**
			 * if the user is from gmail add on  created a new label close the window
			 */

			if (response.status === 202 && queryParameter.action === 'new') {
				window.close();
			} else if (response.status === 202) {

				dispatch(getSharingDetailsPopup([]));

				dispatch(refreshLabels());

				// Webful In-App Analytics
				webfulTrack('label_created');

				// dispatch(resetStates('exceptSelectedContacts'));

				dispatch(contactsLetter(''));

				dispatch(flash({type: 'success', message: translate('labelSuccessfullyCreated').replace('{{labelName}}', name)}));

				/*
				* The new label is selected"
				* */

				ownProps.history.push('/label/' + response.data.contactGroup.groupId);

				/*let currentSelectedContactsGroup = {
					'id': response.data.contactGroup.groupId,
					'name': response.data.contactGroup.name,
					'permission': 'OWNER',
				};

				dispatch(getSelectedContactsGroup(currentSelectedContactsGroup));*/

				/*
				* The user is invited to share this label
				* */

				if (createdFromContactsSharing) {

					if (store.getState().contactReducer.selectedContacts.length > 0) {

						/*
						* One or several contacts selected from checkbox
						* */

						dispatch(
							putLabelToAdd([
									store.getState().contactsGroupItemReducer.getSelectedContactsGroup.id],
								store.getState().contactReducer.selectedContacts,
								null,
								store.getState().contactsGroupItemReducer.getSelectedContactsGroup.name,
								null,
								false,
								true
							)
						);
					} else {

						/*
						* Direct share contact
						* */

						dispatch(
							putLabelToAdd([
									store.getState().contactsGroupItemReducer.getSelectedContactsGroup.id],
								[store.getState().contactReducer.targetedContact],
								null,
								store.getState().contactsGroupItemReducer.getSelectedContactsGroup.name,
								store.getState().contactReducer.targetedContact.name,
								true,
								true,
							)
						);
					}

					dispatch(share(store.getState().contactsGroupItemReducer.getSelectedContactsGroup))

				} else {
					if (store.getState().profileReducer.getProfile
						&& store.getState().profileReducer.getProfile.role !== 'RESTRICTED_USER'
						&& store.getState().profileReducer.getProfile.domain
						&& store.getState().profileReducer.getProfile.domain.plan !== 'INVITED') {
						dispatch(getSharingDetailsPopup([true, 'add_user']));
					} else {
						dispatch(getSharingDetailsPopup([]));
					}
				}


			} else {
				dispatch(getSharingDetailsPopup([]));
				dispatch(flash({type: 'danger', message: translate('msgBarErrorText10')}));
			}


		}).catch(e => {
			if (e.response.data.result) {
				if (queryParameter.action === 'new') {
					let errorText = e.response.data.result
					dispatch(gmailAddOnMsgBar(['error', errorText]));
					setTimeout(() => {
						dispatch(gmailAddOnMsgBar([]));
					}, 3000)
				} else if (e.response.data.result === 'Group with same name already exists') {
					dispatch(flash({type: 'danger', message: translate('labelNameError')}));
				} else {
					dispatch(getSharingDetailsPopup([]));
					if (store.getState().profileReducer.getProfile
						&& store.getState().profileReducer.getProfile.domain
						&& store.getState().profileReducer.getProfile.domain.plan !== 'INVITED'
						&& e.response.status === 409) {
						//let errorText = e.response.data.result
						dispatch(flash({type: 'danger', message: translate('labelNameError')}));
					}
					else if (store.getState().profileReducer.getProfile
						&& store.getState().profileReducer.getProfile.domain
						&& store.getState().profileReducer.getProfile.domain.plan !== 'INVITED') {
						dispatch(getSharingDetailsPopup([true, 'label_creation_limit']));
					} else {
						dispatch(getSharingDetailsPopup([true, 'label_creation_limit_for_invited']));
					}
				}
			} else {
				dispatch(getSharingDetailsPopup([]));
				console.error('Error during label creation:' + e)
			}
		});
	};

}

export function createLabelToAttach(name, sharinginfo, history) {
	return function (dispatch) {
		axios.post(API_ROOT + '/api/v11/label?label_name=' + name, '', {withCredentials: true}).then(response => {
			if (response.status === 202) {

				let forceLabelSelection = {
					id: response.data.contactGroup.groupId,
					name: response.data.contactGroup.name,
					ownerId: response.data.contactGroup.ownerId,
					permission: 'OWNER',
					status: 'NOT_SHARED'
				};

				dispatch(
					putLabelToAdd([
						response.data.contactGroup.groupId],
						sharinginfo[2],
						forceLabelSelection,
						response.data.contactGroup.name,
						sharinginfo[3],
						sharinginfo[4],
						null,
						response.data.contactGroup.ownerId,
						history
					)
				);

				dispatch(refreshLabels());

				//dispatch(msgBar(['success', translate('labelSuccessfullyCreated').replace('{{labelName}}', name)]));

			} else {
				dispatch(flash({type: 'danger', message: translate('msgBarErrorText10')}));
			}
		}).catch(e => {

			if (e.response.data.result) {
				dispatch(getSharingDetailsPopup([]));
				if (e.response.data.result === 'Group name cannot be empty') {
					dispatch(flash({type: 'danger', message: translate('textEmptyLabelError')}));
				} else if (e.response.data.result === 'Group with same name already exists') {
					dispatch(flash({type: 'danger', message: translate('labelNameError')}));
				} else if (store.getState().profileReducer.getProfile
					&& store.getState().profileReducer.getProfile.domain
					&& store.getState().profileReducer.getProfile.domain.plan !== 'INVITED') {
					dispatch(getSharingDetailsPopup([true, 'label_creation_limit']));
				} else {
					dispatch(getSharingDetailsPopup([true, 'label_creation_limit_for_invited']));
				}
			} else {
				dispatch(getSharingDetailsPopup([]));
				console.error('Error during label creation:' + e)
			}

		});
	}


}

export function postCreateLabelToAttach(name) {
	return function (dispatch) {
		axios.post(API_ROOT + '/api/v11/label?label_name=' + name, '', {withCredentials: true}).then(response => {
			if (response.status === 202) {

				dispatch(refreshLabels());

				dispatch(flash({type: 'success', message: translate('labelSuccessfullyCreated').replace('{{labelName}}', name)}));

			} else {
				dispatch(flash({type: 'danger', message: translate('msgBarErrorText10')}));
			}
		}).catch(e => {

			if (e.response.data.result) {
				dispatch(getSharingDetailsPopup([]));
				if (e.response.data.result === 'Group name cannot be empty') {
					dispatch(flash({type: 'danger', message: translate('textEmptyLabelError')}));
				} else if (e.response.data.result === 'Group with same name already exists') {
					dispatch(flash({type: 'danger', message: translate('labelNameError')}));
				} else if (store.getState().profileReducer.getProfile
					&& store.getState().profileReducer.getProfile.domain
					&& store.getState().profileReducer.getProfile.domain.plan !== 'INVITED') {
					dispatch(getSharingDetailsPopup([true, 'label_creation_limit']));
				} else {
					dispatch(getSharingDetailsPopup([true, 'label_creation_limit_for_invited']));
				}
			} else {
				dispatch(getSharingDetailsPopup([]));
				console.error('Error during label creation:' + e)
			}

		});
	}
}

export function putRenameLabel(labelId, name) {

	return function (dispatch) {

		let newName = '';

		if (store.getState().contactsGroupItemReducer.getSelectedContactsGroup.status === 'SHARED') {
			newName = encodeURIComponent(name + ' (Shared)');
		} else {
			newName = encodeURIComponent(name);
		}

		axios.put(API_ROOT + '/mb/label/' + labelId + '/?name=' + newName, '', {withCredentials: true}).then(response => {
			if (response.status === 200) {
				dispatch(getSharingDetailsPopup([]));

				dispatch(getSelectedContactsGroup({
					...store.getState().contactsGroupItemReducer.getSelectedContactsGroup,
					name: name
				}));

				dispatch(refreshLabels());

				dispatch(flash({type: 'success', message: translate('msgBarSuccessRenameText3')}));

			} else {
				dispatch(getSharingDetailsPopup([]));
				dispatch(flash({type: 'danger', message: translate('msgBarErrorRenameText1')}));
			}

		}).catch(e => {
			dispatch(getSharingDetailsPopup([]));
			if (store.getState().profileReducer.getProfile
				&& store.getState().profileReducer.getProfile.domain
				&& store.getState().profileReducer.getProfile.domain.plan !== 'INVITED'
				&& e.response.status === 409) {
				dispatch(flash({type: 'danger', message: translate('textRenameLabelError')}));
			}
			else if (store.getState().profileReducer.getProfile
				&& store.getState().profileReducer.getProfile.domain
				&& store.getState().profileReducer.getProfile.domain.plan !== 'INVITED') {
				dispatch(flash({type: 'danger', message: translate('msgBarErrorRenameText2') + e}))
			} else {
				dispatch(flash({type: 'danger', message: translate('msgBarErrorRenameText3')}));
			}
		});
	};

}

export function putDeleteLabel(labelId, labelName, ownProps) {

	return function (dispatch, getState) {
		axios.put(API_ROOT + '/mb/membership?groupId=' + labelId, [], {withCredentials: true}).then(response => {

			if (response.status === 200) {

				dispatch(getSharingDetailsPopup([]));
				dispatch(getSelectedContactsGroup({
					id: '6',
					name: 'Contacts',
					permission: 'OWNER'
				}));

				dispatch(refreshLabels());

				dispatch(findContacts(getState().contactsGroupItemReducer.getSelectedContactsGroup.id, store.getState().contactReducer.contactsPageSize));

				dispatch(flash({type: 'success', message: translate('msgBarSuccessDeleteText3').replace('{{labelName}}', labelName)}));

				ownProps.history.push('/label/6-' + getState().profileReducer.getProfile.id);

			} else {
				dispatch(getSharingDetailsPopup([]));
				dispatch(flash({type: 'danger', message: translate('msgBarErrorDeleteText1')}));
			}

		}).catch(e => {
			dispatch(getSharingDetailsPopup([]));
			if (e.response.data.result && e.response.data.result === 'Not allowed for Invited Users.') {
				dispatch(flash({type: 'danger', message: translate('msgBarErrorDeleteText2')}));
			} else {
				dispatch(flash({type: 'danger', message: translate('msgBarErrorDeleteText1')}));
			}
		});
	}
}

export function findLabels(pageSize, directLaunch) {

	return function (dispatch, getState) {

		let request = '';
		let checkDirectUrlDetails = getState().contactReducer.contactCardDetails;
		let groupId = '';
		let ownerId = '';
		if (checkDirectUrlDetails?.groupId) {
			groupId = checkDirectUrlDetails.groupId;
			ownerId = checkDirectUrlDetails.ownerId;
		}

		if (pageSize) {
			request = API_GET_CONTACT_GROUPS_URL + '?pageSize=' + pageSize + '&groupId=' + groupId + '&ownerId=' + ownerId + '&page=' + getState().contactsGroupItemReducer.labelsPageNumber;
		} else {
			request = API_GET_CONTACT_GROUPS_URL + '?page=' + getState().contactsGroupItemReducer.labelsPageNumber + '&ownerId=' + ownerId + '&groupId=' + groupId;
		}

		axios.get(request, {withCredentials: true}).then(response => {

			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			//const product = urlParams.get('userId');

			if (
				response.data.contactsGroups.length === 0 &&
				urlParams.get('action') === 'share' &&
				urlParams.get('userId') > 0 &&
				window.location.pathname.includes('/popup/contact')
			) {
				dispatch({type: 'GMAIL_ADD_ON_SHARE_CONTACT'});
			}
			if (checkDirectUrlDetails?.groupId && response.data.state === 'SUCCEED') {
				let currentSelectedContactsGroup = {
					'id': response.data.contactsGroups[0].id,
					'name': response.data.contactsGroups[0].name,
					'permission': response.data.contactsGroups[0].permission,
					'ownerId': response.data.contactsGroups[0].ownerId,
					'slaveGroupId': response.data.contactsGroups[0]?.slaveGroupId
				};
				dispatch(getSelectedContactsGroup(currentSelectedContactsGroup));
			}

			/*
			* To avoid the previous page loading when scrollTop = 0 when label list is reloading
			* */

			/*if(document.querySelector(".list-of-labels-body-content") && store.getState().contactsGroupItemReducer.labelsPageNumber > 1){
				document.querySelector(".list-of-labels-body-content").scrollTop = 1;
			}*/

			dispatch(labelsToState(response, pageSize));

		}).catch(e => {
			dispatch(getSharingDetailsPopup([true, 'labels_loading_error', e.message]));
		});

	}
}

let timeOutFunc = null;

export function labelsToState(response, pageSize) {
	return function (dispatch, getState) {

		if (getState().contactsGroupItemReducer.hasSharedLabels) {
			dispatch(hasSharedLabels(false));
		}

		if (getState().contactsGroupItemReducer.hasCollaboratorsPending) {
			dispatch(hasCollaboratorsPending(false));
		}

		dispatch({
			type: 'FIND_LABELS',
			payload: response.data
		});

		/*
		* Update the contacts list
		* */

		/*if (getState().contactsGroupItemReducer.getSelectedContactsGroup) {
			if(getState().contactsGroupItemReducer.getSelectedContactsGroup.type === "system"){
				if (getState().contactReducer.contactsLetter === '') {
					dispatch(findContacts(6, getState().contactReducer.contactsPageSize));
				} else {
					dispatch(findContacts(6, getState().contactReducer.contactsPageSize, getState().contactReducer.contactsLetter));
				}
			} else {
				if (getState().contactReducer.contactsLetter === '') {
					dispatch(findContacts(getState().contactsGroupItemReducer.getSelectedContactsGroup.id, getState().contactReducer.contactsPageSize));
				} else {
					dispatch(findContacts(getState().contactsGroupItemReducer.getSelectedContactsGroup.id, getState().contactReducer.contactsPageSize, store.getState().contactReducer.contactsLetter));
				}
			}

		}*/

		if (response.data.state === 'SUCCEED') {

			let bHasSharedLabels = false;
			let bHasCollaboratorsPending = false;

			if (getState().contactsGroupItemReducer.isLabelsLoading) {
				dispatch(isLabelsLoading(false));
			}

			if (response.data.contactsGroups.length > 0) {

				if (window.dataLayer) {
					window.dataLayer.push({
						'hasGroups': 'true',
						event: 'hasGroups'
					});
				}

				getState().contactsGroupItemReducer.findLabels.contactsGroups.forEach(contactsGroupItem => {

					/*
					* Find pending collaborators on label sharing preview
					* */

					if (contactsGroupItem.status === 'SHARED') {
						bHasSharedLabels = true;
					}

					/*
					* Find pending collaborators on label sharing preview
					* */

					contactsGroupItem.sharingPreview.find(item => {
						if (item.statuses.invitationPending || item.statuses.invitationWarning) {
							bHasCollaboratorsPending = true;
						}

						return null;
					});

					/*
					* Update selected label
					* */

					if (getState().contactsGroupItemReducer.getSelectedContactsGroup !== null) {
						if (contactsGroupItem.id === getState().contactsGroupItemReducer.getSelectedContactsGroup.id && !('groupId' in getState().contactReducer.contactCardDetails)) {
							dispatch(getSelectedContactsGroup(contactsGroupItem));
						}
					}

					return null;
				});

				if (bHasSharedLabels) {
					dispatch(hasSharedLabels(true))
				} else {
					dispatch(hasSharedLabels(false));
					dispatch(tutorialPopup(true));
				}

				if (bHasCollaboratorsPending) {
					dispatch(hasCollaboratorsPending(true));
					dispatch(tutorialPopup(true));
				} else {
					dispatch(hasCollaboratorsPending(false));
				}

				if(response.data.pages.totalPages > 1){
					if(getState().contactsGroupItemReducer.allLabelsFetched){
						dispatch(allLabelsFetched(false));
					}
					dispatch(findNextLabels(pageSize, getState().contactsGroupItemReducer.labelsPageNumber + 1))
				} else {
					dispatch(allLabelsFetched(true));
				}

			}

		} else if (response.data.state === 'RUNNING') {

			if(getState().contactsGroupItemReducer.waitingContactsGroupsLevel < 1){
				timeOutFunc = setTimeout(() => {
					dispatch(findLabels(pageSize, true));
					clearTimeout(timeOutFunc);
					dispatch(waitingContactsGroupsLevel(getState().contactsGroupItemReducer.waitingContactsGroupsLevel + 1));
				}, 2000);
			} else if(getState().contactsGroupItemReducer.waitingContactsGroupsLevel < 2){
				timeOutFunc = setTimeout(() => {
					dispatch(findLabels(pageSize, true));
					clearTimeout(timeOutFunc);
					dispatch(waitingContactsGroupsLevel(getState().contactsGroupItemReducer.waitingContactsGroupsLevel + 1));
				}, 3000);
			} else {
				dispatch(waitingContactsGroupsLevel(getState().contactsGroupItemReducer.waitingContactsGroupsLevel + 1));
			}

		} else if (response.data.state === 'FAIL') {
			dispatch(getSharingDetailsPopup([true, 'labels_loading_error', response.data.message]));
		} else {
			dispatch(getSharingDetailsPopup([true, 'labels_loading_error', 'Unknown error']));
		}
	}
}

export function findNextLabels(pageSize, pageNumber) {
	return function (dispatch) {

		let request = '';

		if (pageSize) {
			if(pageNumber){
				request = API_GET_CONTACT_GROUPS_URL + '?pageSize=' + pageSize + '&groupId=&ownerId=&page=' + pageNumber;
			} else {
				request = API_GET_CONTACT_GROUPS_URL + '?pageSize=' + pageSize + '&groupId=&ownerId=';
			}
		} else {
			if(pageNumber){
				request = API_GET_CONTACT_GROUPS_URL + '?page=' + pageNumber + '&ownerId=&groupId=';
			} else {
				request = API_GET_CONTACT_GROUPS_URL;
			}
		}

		axios.get(request, {withCredentials: true}).then( response => {

			dispatch({
				type: "FIND_NEXT_LABELS",
				payload: response.data
			});

			let callNextLabels = setTimeout(() => {

				if((window.location.pathname === "/" || window.location.pathname.includes("/label/") || window.location.pathname.includes("/contact/")) && response.data.pages.next !== null){
					dispatch(findNextLabels(pageSize, response.data.pages.next + 1))
				} else {
					clearTimeout(callNextLabels);
					dispatch(allLabelsFetched(true));
				}

			}, 1000);

		});
	}
}

export function findLabelsByType(type, pageSize) {
	return function (dispatch) {

		let request = '';
		let found = 0;

		if (type && pageSize) {
			request = API_GET_CONTACT_GROUPS_URL + '?type=' + type + '&pageSize=' + pageSize + '&page=' + store.getState().contactsGroupItemReducer.labelsPageNumber;
		} else if (type && pageSize === undefined) {
			request = API_GET_CONTACT_GROUPS_URL + '?type=' + type + '&page=' + store.getState().contactsGroupItemReducer.labelsPageNumber;
		} else if (type === undefined && pageSize) {
			request = API_GET_CONTACT_GROUPS_URL + '?pageSize=' + pageSize + '&page=' + store.getState().contactsGroupItemReducer.labelsPageNumber;
		} else {
			request = API_GET_CONTACT_GROUPS_URL + '?page=' + store.getState().contactsGroupItemReducer.labelsPageNumber;
		}

		axios.get(request, {withCredentials: true}).then(response => {

			/*
			* To avoid the previous page loading when scrollTop = 0 when label list is reloading
			* */

			/*if(document.querySelector(".list-of-labels-body-content") && store.getState().contactsGroupItemReducer.labelsPageNumber > 1){
				document.querySelector(".list-of-labels-body-content").scrollTop = 1;
			}*/

			dispatch({
				type: 'FIND_LABELS_BY_TYPE',
				payload: response.data
			});

			/*
			* Refresh the selected contacts group
			* */

			if (store.getState().contactsGroupItemReducer.getSelectedContactsGroup) {

				let selectedContactsGroup = store.getState().contactsGroupItemReducer.getSelectedContactsGroup;

				response.data.contactsGroups.forEach(contactsGroup => {
					if (contactsGroup.id === selectedContactsGroup.id) {
						found = found + 1;
						dispatch(getSelectedContactsGroup(contactsGroup));
					}
				});

				/*
				* If the label cannot be found on the label filtered status, it's unselected.
				* */

				if (found > 0) {
					/*
					* Update the contacts list, both labels and system Contact (for instance in case the user attach a label to a contact)
					* */

					dispatch(findContacts(store.getState().contactsGroupItemReducer.getSelectedContactsGroup.id, store.getState().contactReducer.contactsPageSize));

				} else {
					dispatch(getSelectedContactsGroup({
						id: '6',
						name: 'Contacts',
						ownerId: store.getState().contactsGroupItemReducer.getSelectedContactsGroup.ownerId,
						slaveGroupId: store.getState().contactsGroupItemReducer.getSelectedContactsGroup?.slaveGroupId
					}));

					dispatch(findContacts(store.getState().contactsGroupItemReducer.getSelectedContactsGroup.id, store.getState().contactReducer.contactsPageSize));

				}
			}
		}).catch((e) => {
			console.log(e)
		})
	}
}

export function isLabelsLoading(boolean) {
	return {
		type: 'IS_LABELS_LOADING',
		payload: boolean
	}
}

export function isNewLabelsLoading(boolean) {
	return {
		type: 'IS_NEW_LABELS_LOADING',
		payload: boolean
	}
}

export function loadNewLabels(pageSize, nextPage) {

	return function (dispatch) {
		axios.get(API_GET_CONTACT_GROUPS_URL + '?pageSize=' + pageSize + '&page=' + nextPage, {withCredentials: true}).then((response) => {

			dispatch({
				type: 'LOAD_NEW_LABELS',
				payload: response.data.contactsGroups
			});
		}).then(() => {
			dispatch(labelsPageSize(store.getState().contactsGroupItemReducer.labelsPageSize + store.getState().contactsGroupItemReducer.labelsPageSize));
		});
	};
}

export function labelStateUpdating(labelId) {
	return {
		type: 'LABEL_STATE_UPDATING',
		payload: labelId
	}
}

export function labelsPageNumber(int) {
	return {
		type: 'LABELS_PAGE_NUMBER',
		payload: int
	};
}

export function popupLabelsPageNumber(int) {
	return {
		type: 'POPUP_LABELS_PAGE_NUMBER',
		payload: int
	};
}

export function labelsPageSize(int) {
	return {
		type: 'LABELS_PAGE_SIZE',
		payload: int
	};
}

export function getSelectedContactsGroup(object) {
	return {
		type: 'GET_SELECTED_CONTACTS_GROUP',
		payload: object
	};
}

export function selectSeveralContactsGroups(array) {
	return {
		type: 'SELECT_SEVERAL_CONTACTS_GROUPS',
		payload: array
	};
}

export function resetStates(derogation) {
	return function (dispatch, getState) {

		/*
		* Reset next contact call
		* */

		if(getState().contactReducer.loadNextContacts){
			dispatch(loadNextContacts(false));
		}

		/*
		* Reset Contacts Groups gradual wait
		* */

		if(getState().contactsGroupItemReducer.waitingContactsGroupsLevel > 0){
			dispatch(waitingContactsGroupsLevel(0));
		}

		/*
		* Reset Directory Contacts gradual wait
		* */

		if(getState().directoryGroupReducer.waitingDirectoryGroupsLevel > 0) {
			dispatch(waitingDirectoryGroupsLevel(0));
		}

		/*
		* Close Add contact button
		* */

		if (getState().contactReducer.extendAddContactBtn) {
			dispatch(extendAddContactBtn(false));
		}

		/*
		* Remove label state updating loader
		* */

		if(getState().contactsGroupItemReducer.labelStateUpdating){
			dispatch(labelStateUpdating(null));
		}

		/*
		* Reset eventual selected contacts
		* */
		/**
		 * as there is no document of id massContactsSelection so we check if the user is from gmailAddon we overpass it
		 */

		let checkGmailAddOnTab = getState().profileReducer.setGmailAddOnData;
		if ('checkGmailAddon' in checkGmailAddOnTab) {

		} else {
			if (document.getElementById('massContactsSelection')) {
				document.getElementById('massContactsSelection').checked = false;
			}
		}

		/*
		* Empty contact filter
		* */

		if(getState().contactReducer.enteredContactSearchValue !== "") {
			dispatch(enteredContactSearchValue(''));
		}

		/*
		* Empty modal contact filter
		* */

		if(getState().contactReducer.enteredModalContactSearchValue !== "") {
			dispatch(enteredModalContactSearchValue(''));
		}

		/*
		* Empty collaborator filter
		* */

		if(getState().sharingDetailsReducer.enteredCollaboratorSearchValue !== "") {
			dispatch(enteredCollaboratorSearchValue(''));
		}

		/**
		 * Empty all the collaborators to hardly reload the same collaborators between two Contacts Group except for domainGroupDetails entrance
		 */

		if (derogation && derogation.includes('exceptCollaborators') === false) {
			if (getState().sharingDetailsReducer.findCollaborators !== null) {
				dispatch(resetCollaborators());
			}
		}

		/**
		 * By selecting another contacts group, the eventual users to update must be forgotten.
		 */

		if (getState().sharingDetailsReducer.updateCollaborators.length > 0) {
			dispatch(updateCollaborators([]));
		}

		/**
		 * Eventual previous flash should be removed.
		 */

		/*if (getState().sharingDetailsReducer.flash) {
			dispatch(flash(null));
		}*/

		/**
		 * Eventual selectedCollaborators and collaborators domain groups are emptied except for domainGroupDetails entrance
		 */

		if (derogation && derogation.includes('exceptCollaborators') === false) {
			if (getState().sharingDetailsReducer.selectedCollaborator !== null) {
				dispatch(selectedCollaborator(null));
				dispatch(resetDomainGroup());
			}
		}


		/**
		 * If SHARED WITH ME display mode is active following a Owner change, switch to off on contacts group selection change
		 */

		if (getState().sharingDetailsReducer.sharedWithMeDisplayMode) {
			dispatch(sharedWithMeDisplayMode(false));
		}

		/**
		 * If a ownership change was processing and then you select another contacts group
		 */

		if (getState().sharingDetailsReducer.ownershipChangeTarget !== null) {
			dispatch(ownershipChangeTarget(null));
		}

		/**
		 * If updateCollaborator is empty, the save/cancel change UI must be off
		 */

		dispatch(checkUpdates());

		/**
		 * Reset contacts & collaborator search
		 */
		if ('checkGmailAddon' in checkGmailAddOnTab) {

		} else {
			if (document.querySelector('.list-of-contacts-header .search-bar input')) {
				document.querySelector('.list-of-contacts-header .search-bar input').value = '';
			}
		}

		if(getState().sharingDetailsReducer.getAutoComplete.length) {
			dispatch(resetAutoComplete());
		}

		if(getState().contactReducer.contactSearchResult) {
			if (getState().contactReducer.contactSearchResult.contacts.length > 0) {
				dispatch(resetContactSearchResult());
			}
		}

		if(getState().contactReducer.modalContactSearchResult) {
			if (getState().contactReducer.modalContactSearchResult.contacts.length > 0) {
				dispatch(resetModalContactSearchResult());
			}
		}

		/*
		* Unselect labels to add
		* */

		if (getState().contactReducer.selectLabelToAdd.length > 0) {
			dispatch(selectLabelToAdd([]))
		}

		/*
		* Unselect contacts to add
		* */

		if (getState().contactReducer.selectContactToAdd.length > 0) {
			dispatch(selectContactToAdd([]));
		}

		/*
		* Contact pagination reset
		* */

		if(getState().contactReducer.contactsPageNumber > 1) {
			dispatch(contactsPageNumber(1));
		}

		/*
		* Contact Result pagination reset
		* */

		if(getState().contactReducer.contactSearchResultPageNumber > 1){
			dispatch(contactSearchResultPageNumber(1));
		}

		/*
		* Remove the confirm contact research set to true when enter is pressed on Contact SearchBar
		* */

		if(getState().contactReducer.confirmContactResearch) {
			dispatch(confirmContactResearch(false));
		}

		/*
		* Remove the advanced mode of contact research initially set for the contact pagination to not call the wrong API.
		* */

		if(getState().contactReducer.isContactsSearchAdvancedMode){
			dispatch(isContactsSearchAdvancedMode(false));
		}

		/*
		* Remove the payload reminder of the contacts advanced search
		* */

		if (getState().contactReducer.contactsAdvancedSearchRequest) {
			dispatch(contactsAdvancedSearchRequest(null));
		}

		/*
		* Contact Details edit mode removed
		* */

		if(getState().contactReducer.contactDetailsEditMode){
			dispatch(contactDetailsEditMode(false));
		}

		/*
		* Reset Added Collaborators
		* */

		if (
			getState().sharingDetailsReducer.getAddedCollaborators.length > 0
			&& (!getState().sharingDetailsReducer.getSharingDetailsPopup || getState().sharingDetailsReducer.getSharingDetailsPopup.length === 0)
		) {
			dispatch(resetAddedCollaborators(false));
		}

		/*
		* Reset selected contacts
		* */

		if(getState().contactReducer.selectedContacts.length > 0){
			dispatch(selectedContacts([]));
			document.querySelectorAll('.contact .custom-control-input').forEach(item => item.checked = false);
		}

		/*
		* Reset advanced search
		* */

		if(getState().contactReducer.isContactsAdvancedSearchDropDown){
			dispatch(setIsContactsAdvancedSearchDropDown(false))
		}


	};
}

export function getEnteredSearchValue(object) {
	return {
		type: 'GET_ENTERED_SEARCH_VALUE',
		payload: object
	};
}

export function getFilteredStatus(object) {
	return {
		type: 'GET_FILTERED_STATUS',
		payload: object
	};
}

export function changeContactsGroupStatus(id, string) {
	return {
		type: 'CHANGE_CONTACTS_GROUP_STATUS',
		payload: [id, string]
	};
}

export function checkComponentRendering(boolean) {
	return {
		type: 'CHECK_COMPONENT_RENDERING',
		payload: boolean
	}
}

export function hasSharedLabels(boolean) {
	return {
		type: 'HAS_SHARED_LABELS',
		payload: boolean
	};
}

export function hasCollaboratorsPending(boolean) {
	return {
		type: 'HAS_COLLABORATORS_PENDING',
		payload: boolean
	};
}

export function allLabelsFetched(boolean) {
	return {
		type: 'ALL_LABELS_FETCHED',
		payload: boolean
	};
}

export function selectOneLabelFromPopup (object) {
	return {
		type: 'SELECT_ONE_LABEL_FROM_POPUP',
		payload: object
	};
}

export function displayLabelSearch (boolean) {
	return {
		type: 'DISPLAY_LABEL_SEARCH',
		payload: boolean
	};
}

export function contactLabelsToCollapse (object) {
	return function (dispatch, getState) {
		getState().contactsGroupItemReducer.findLabels.contactsGroups.forEach( item => {
			if(object.labelType === "contact"){
				if(item.id === object.labelId){
					dispatch(isContactLabelCollapsed([
						...getState().contactsGroupItemReducer.isContactLabelCollapsed,
						object.labelId
					]));

					if(item.childContactGroups){
						item.childContactGroups.forEach(childContactItem => {
							if(getState().contactsGroupItemReducer.isContactLabelHidden.includes(childContactItem.id) === false) {
								dispatch(isContactLabelHidden([
									...getState().contactsGroupItemReducer.isContactLabelHidden,
									childContactItem.id
								]));
							}

							if(childContactItem.childContactGroups) {
								childContactItem.childContactGroups.forEach(childContactItemLv2 => {
									if (getState().contactsGroupItemReducer.isContactLabelHidden.includes(childContactItemLv2.id) === false) {
										dispatch(isContactLabelHidden([
											...getState().contactsGroupItemReducer.isContactLabelHidden,
											childContactItemLv2.id
										]))
									}
								})
							}
						})
					}

				}
			} else {
				if (item.childContactGroups) {
					item.childContactGroups.forEach(childContactItem => {
						if(childContactItem.id === object.labelId) {
							if (childContactItem.id === object.labelId) {

								if (getState().contactsGroupItemReducer.isContactLabelCollapsed.includes(object.labelId) === false) {
									dispatch(isContactLabelCollapsed([
										...getState().contactsGroupItemReducer.isContactLabelCollapsed,
										object.labelId
									]));
								}

								if (childContactItem.childContactGroups) {
									childContactItem.childContactGroups.forEach(childContactItemLv2 => {
										if (getState().contactsGroupItemReducer.isContactLabelHidden.includes(childContactItemLv2.id) === false) {
											dispatch(isContactLabelHidden([
												...getState().contactsGroupItemReducer.isContactLabelHidden,
												childContactItemLv2.id
											]))
										}
									})
								}

							}
						}
					})
				}
			}
		})
	}
}

export function contactLabelsToExpend (object) {
	return function (dispatch, getState) {
		dispatch(isContactLabelCollapsed([...getState().contactsGroupItemReducer.isContactLabelCollapsed.filter((collapsedItem) => collapsedItem !== object.labelId)]));

		getState().contactsGroupItemReducer.findLabels.contactsGroups.forEach( item => {
			if(object.labelType === "contact"){

				if(item.customerId === object.customerId){
					if(item.childContactGroups){
						item.childContactGroups.forEach(childContactItem => {

							dispatch(isContactLabelHidden([...getState().contactsGroupItemReducer.isContactLabelHidden.filter((collapsedItem) => collapsedItem !== childContactItem.id)]));
							dispatch(isContactLabelCollapsed([...getState().contactsGroupItemReducer.isContactLabelCollapsed.filter((collapsedItem) => collapsedItem !== childContactItem.id)]));

							if(childContactItem.childContactGroups) {
								childContactItem.childContactGroups.forEach(childContactItemLv2 => {
									dispatch(isContactLabelHidden([...getState().contactsGroupItemReducer.isContactLabelHidden.filter((collapsedItem) => collapsedItem !== childContactItemLv2.id)]));
								});
							}
						})
					}
				}

			} else {
				if (item.childContactGroups) {
					item.childContactGroups.forEach(childContactItem => {
						if (childContactItem.id === object.labelId) {

							if (getState().contactsGroupItemReducer.isContactLabelCollapsed.includes(object.labelId) === false) {
								dispatch(isContactLabelCollapsed([...getState().contactsGroupItemReducer.isContactLabelCollapsed.filter((collapsedItem) => collapsedItem !== object.labelId)]));
							}

							if(childContactItem.childContactGroups) {
								childContactItem.childContactGroups.forEach(childContactItemLv2 => {
									dispatch(isContactLabelHidden([...getState().contactsGroupItemReducer.isContactLabelHidden.filter((collapsedItem) => collapsedItem !== childContactItemLv2.id)]));
								});
							}
						}
					})
				}
			}
		});
	}
}

export function isContactLabelCollapsed (array) {
	return {
		type: "IS_CONTACT_LABEL_COLLAPSED",
		payload: array
	};
}

export function isContactLabelHidden (array) {
	return {
		type: "IS_CONTACT_LABEL_HIDDEN",
		payload: array
	};
}

export function labelDropdown (string) {
	return {
		type: "LABEL_DROPDOWN",
		payload: string
	};
}

export function waitingContactsGroupsLevel (boolean) {
	return {
		type: "WAITING_CONTACTS_GROUPS_LEVEL",
		payload: boolean
	};
}
